export const numericOnlyAllowableKeys = [
    37, 39, 45, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 190, 9, 46, 8, 13, 91, 17, 96, 97, 98, 99, 100, 101, 102, 103,
    104, 105, 108, 109, 110, 173, 189,
];
